export default "__VITE_ASSET__831d07e4__"